module.exports = __webpack_public_path__ + "static/IMG-3-28c825cec50f1b81c7ea70d915b962ea.jpg";